import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/seanrioux/products/open-source-okr/code/react-okr-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "about"
    }}>{`About`}</h1>
    <p>{`OKR UI is an open source project, released under MIT License.`}</p>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <p>{`OKR UI provides everything you'll need to quickly build OKR experiences:`}</p>
    <h3 {...{
      "id": "components"
    }}>{`Components`}</h3>
    <p>{`A collection of highly compositional components for a wide range of possible OKR UI requirements:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`OKR`}</strong>{`: contain your OKR and configure`}</li>
      <li parentName="ul"><strong parentName="li">{`Objective`}</strong>{`: contain and layout your objective`}</li>
      <li parentName="ul"><strong parentName="li">{`Goal`}</strong>{`: display your objective, and calculate result text from props`}</li>
      <li parentName="ul"><strong parentName="li">{`Due date`}</strong>{`: process and display a due date with label`}</li>
      <li parentName="ul"><strong parentName="li">{`Progress bar:`}</strong>{` display a provided percentage value, or calculate percentage progress from results`}</li>
      <li parentName="ul"><strong parentName="li">{`Result:`}</strong>{` contain and layout your key result`}</li>
      <li parentName="ul"><strong parentName="li">{`Current value:`}</strong>{` display a current value, with label in a specific metric (e.g., percentage, money, etc.)`}</li>
    </ul>
    <h3 {...{
      "id": "services"
    }}>{`Services`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Calculate progress:`}</strong>{` take in results and return objective progress.`}</li>
      <li parentName="ul"><strong parentName="li">{`Calculate grade:`}</strong>{` calculate result grade from score.`}</li>
      <li parentName="ul"><strong parentName="li">{`Calculate score:`}</strong>{` calculate score from start, end, and current result value.`}</li>
    </ul>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <p>{`As much as possible OKR UI has been designed to apply to a range of requirements. Configure:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Metrics:`}</strong>{` what metrics do you measure? Keep results consistent with pre-defined metrics.`}</li>
      <li parentName="ul"><strong parentName="li">{`Grades:`}</strong>{` how do you measure success? Customize how progress and score is graded.`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "first-principles"
    }}>{`First principles`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Strongly compositional:`}</strong>{` quickly scaffold UI and maintain data visibility.`}</li>
      <li parentName="ul"><strong parentName="li">{`Minimal dependencies:`}</strong>{` low bloat. Just components and a few helpful utilities.`}</li>
      <li parentName="ul"><strong parentName="li">{`Un-opinionated:`}</strong>{` limited assumptions. Manage state, data, style, your way.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      